const local = '/pro/m'; // :lang or '' 多语言是否配置在路径中

export default {
  // 未登录，允许访问的地址
  noLogin: [
    'index',
    'submit_data',
    'register',
    'login',
    'future_guest',
    'stableFaq',
    'stableInfo',
    'anniversary',
    'earnFaq',
    'rewardCenter',
    'worldCup',
    'appTest',
    'contractContest',
  ],
  index: `${local}/`,
  // 提交快速买卖
  submit_data: `${local}/submit`,
  // 注册
  register: `${local}/signup`,
  // register: `${local}/register`,
  // 登录
  login: `${local}/login`,
  // 合约答题
  future_guest: `${local}/contract/guest`,
  stableFaq: `${local}/stable/faq`,
  stableInfo: `${local}/stable/info`,
  // 周年庆
  anniversary: `${local}/anniversary`,
  // 理财
  earnFaq: `${local}/earn/faq`,
  // 活动
  rewardCenter: `${local}/rewardcenter`,
  // 世界杯
  worldCup: `${local}/worldcup`,
  // app 的 JSBridge 测试配置
  appTest: `${local}/apptest`,
  // 合约大赛
  contractContest: `${local}/contract_contest`,
};
